<template lang="pug">
    v-dialog( fullscreen max-width="80%" v-model="open" )
        v-toolbar( color="grey darken-4" dark sticky flat )
            v-toolbar-title Detalle de factura  
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-card
            v-layout.pa-3( row wrap )
                v-flex( xs12 )
                    crud-form(:fields="fld" noButtons)
                        crud-data-table(
                            :service="service"  
                            :headers="headerTable" 
                            showAll 
                            noActions 
                            slot="appendContent"
                            :filters="[]"
                            noSearchBox
                            )
            
</template>

<script>
import { CrudDataTable, CrudForm } from '@/components/reusable_components'
import {
    getFetchDataFunction,
    generateFetchDataFunction,
} from '@/services/api/DataTableServiceFromFinanzas'
import InvoiceService from '@/services/api/invoice/'
import headerTable from './headers/headerTable.js'
import fieldForm from './fields/fieldsForm.js'
export default {
    name: 'invoice-Detail',
    props: {
        invoiceId: {
            type: String,
            required: true,
        },
        /**
         * @description
         */
        readOnly: {
            type: Boolean,
            default: () => false
        },
    },
    data: function() {
        return {
            open: false,
            service: {
                dtFetchData: () => {},
                dtDeleteItem: () => {},
            },
            headerTable: headerTable,
            fieldsForm: fieldForm
        }
    },
    computed: {
        /**
         * @description
         */
        fld: function(){
            if(this.readOnly) return this.fieldsForm.map(field => {
                field.type = 'readonly'
                return field
            })
            return this.fieldsForm
        },
    },
    methods: {
        toggleOpen() {
            this.open = !this.open
        },
        /**
         *
         */
        getInvoiceRecentInformation() {
            const include = ['sl_detail_sale_invoices.wh_product']
            const idInvoice = this.invoiceId
            const url = process.env.VUE_APP_API_ROUTE.concat(
                `/sl_sale_invoice/${idInvoice}`
            )

            this.service.dtFetchData = getFetchDataFunction(
                url,
                include,
                [],
                response => {
                    let newResponse = {}
                    newResponse.data = [
                        ...response.data.sl_detail_sale_invoices,
                    ]
                    return newResponse
                }
            )
        },
        /**
         *
         */
        async getGeneralInfoInvoice() {
            let response = await InvoiceService.fetchById(this.invoiceId)
            this.fillForm(response)
        },
        /**
         *
         */
        fillForm(data) {
            let fields = [...this.fieldsForm]
            fields[0].value = this.typeSiiDocument(data.dte_type_invoice)
            fields[1].value = data.number
            fields[2].value = data.net_total
            fields[3].value = data.iva
            fields[4].value = data.total
            fields[5].value = data.global_discount_percentage
            fields[6].value = data.global_discount_amount
            this.fieldsForm = [...fields]
        },
        /**
         *
         */
        typeSiiDocument(code) {
            const SII_DOCUMENTS = [
                {
                    code: 33,
                    name: 'Factura Electrónica',
                },
                {
                    code: 39,
                    name: 'Boleta Electrónica',
                },
                {
                    code: 61,
                    name: 'Nota de crédito',
                },
            ]
            let foundDocument = SII_DOCUMENTS.filter(item => {
                if (item.code === code) {
                    return item
                }
            })
            return foundDocument
                ? foundDocument[0].name
                : `código ${code} no encontrado`
        },
    },
    watch: {
        open(val) {
            if (val == true) {
                this.getInvoiceRecentInformation()
                this.getGeneralInfoInvoice()
            }
        },
    },
    components: {
        CrudDataTable,
        CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // mounted: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // beforeUpdate: function(){...},
    updated: function() {
        //this.getInvoiceRecentInformation()
    },
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>